import React, { useEffect, useState } from "react";
import { Menu, Dropdown, Avatar, Badge, Row, Col, Button } from "antd";
import { DownOutlined } from "@ant-design/icons";
import styles from "./index.module.scss";
// import { history, useModel } from 'umi';
import Logo from "../Logo";
import { stringify } from "querystring";

import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { UserOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import DrawerMenu from "../DrawerMenu";
import Icon from "@mdi/react";
import { mdiCart } from "@mdi/js";
import axios from "axios";
import { useLiff } from "react-liff";
import { LINE_ID } from "../../config";

export type TopNavbarProps = {
  src?: string;
  width?: number;
  height?: number;
  logoPath?: string;
};

const TopNavbar: React.FC<TopNavbarProps> = (props) => {
  const user = useSelector((state: any) => state.user);
  const currentAddress = useSelector((state: any) => state.currentAddress);

  const { logoPath } = props;
  const navigate = useNavigate();

  const [currentUser, setCurrentUser] = useState<any>({});

  const menus = [
    {
      name: "ข้อกำหนดและเงื่อนไข",
      link: "/TermsOfUse",
      onClick: () => {
        navigate("/TermsOfUse");
      },
    },
    {
      name: "นโยบายความเป็นส่วนตัว",
      link: "/PrivacyNotice",
      onClick: () => {
        navigate("/PrivacyNotice");
      },
    },
    // {
    //   name: "นโยบายการใช้งานคุกกี้",
    //   link: "/CookiesNotice",
    //   onClick: () => {
    //     navigate("/CookiesNotice");
    //   },
    // },
    {
      name: "ตั้งค่าการยอมรับสิทธิต่างๆ ",
      link: "/DataSubjectRequests",
      onClick: () => {
        navigate("/DataSubjectRequests");
      },
    },
  ];

  const onMenuClick = (item: any) => {
    if (item.onClick) {
      item.onClick();
    }
  };

  const onChatClick = () => {
    // console.log(`go to chat ${LINE_ID}`);

    const url = `https://line.me/R/ti/p/${LINE_ID}`;
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (user._id) {
      // getCarts(user._id);
    }
    setCurrentUser(user);
  }, [user]);

  return (
    <>
      <div className={styles.navbarContainer}>
        <div className={styles.sectionLeft}></div>
        {currentUser.displayName && (
          <div className={styles.rightContentWrapper}>
            <div className={[styles.menuItem, styles.mainMenus].join(" ")}>
              <ul>
                {menus.map((item: any, index: number) => (
                  <li key={index}>
                    <a
                      style={{ fontSize: 15 }}
                      onClick={() => {
                        onMenuClick(item);
                      }}
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        <div className={styles.bottomRightWrapper}>
          {/* <div className={styles.logoBottom}>
            <Logo width={70} height={56} path={logoPath} />
          </div> */}
          <div className={styles.chatWrapper}>
            <Button className={`${styles.chatButton}`} onClick={onChatClick}>
              <img
                className={`${styles.chatButtonImg}`}
                src={`/images/chaticon.png`}
              />
              &nbsp;
              <span className={`${styles.chatButtonText}`}>แชทกับเรา</span>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default TopNavbar;
